<div class="login-container">
  <div class="login-card">
    <h2>Welcome Back</h2>
    <p class="subtitle">Enter your password to continue</p>

    <form class="formborder" #df="ngForm" novalidate>
      <div class="row m-0 col-md-12 p-0">
        <div class="col-md-12">
          <span class="required-lables">Password</span>
          <div class="datepicker_feild position-relative">
            <input
              [type]="showPassword ? 'text' : 'password'"
              name="Password"
              id="Password"
              class="form-control input-text-css"
              placeholder="Enter your password"
              [(ngModel)]="password"
              #refPassword="ngModel"
              required
              [ngClass]="{
                'is-invalid': df.submitted && refPassword.invalid,
                'alert-warning':
                  refPassword.invalid &&
                  (refPassword.dirty || refPassword.touched || refPassword.untouched)
              }"
            />
            <button
              type="button"
              class="btn-eye-toggle"
              (click)="toggleShowPassword()"
              tabindex="-1"
            >
              <i [class]="showPassword ? 'fa fa-eye' : 'fa fa-eye-slash'"></i>
            </button>
          </div>
          <div *ngIf="df.submitted && refPassword.hasError('required')" class="text-danger font-size-12">
            Password is required.
          </div>
          <div *ngIf="df.submitted && refPassword.hasError('minlength')" class="text-danger font-size-12">
            Password must be at least 6 characters.
          </div>
        </div>
      </div>

      <div *ngIf="Message" class="row m-0 col-md-12 p-0 mt-2">
        <div class="col-md-10 offset-md-1 text-success font-size-12">
          {{ Message }}
        </div>
      </div>

      <div class="col-md-12 d-flex justify-content-center mt-3">
        <button
          type="button"
          class="btn font-size-12 button-btn"
          [disabled]="!df.form.valid || isLoading"
          [class.spinnerInside]="isLoading"
          (click)="onSubmit(df)"
        >
          <span *ngIf="!isLoading">Login</span>
          <span *ngIf="isLoading">Loading...</span>
        </button>
      </div>
    </form>
  </div>
</div>